import React, { FC, useEffect, useState } from 'react';
import Slider from '@react-native-community/slider';
import { Animated, StyleSheet, View } from 'react-native';
import { COLORS, NEUTRAL_TEXT500 } from '../../config/designSystem/Colors';
import { ParagraphMRegular, ParagraphSRegular } from '../../config/designSystem/typography';
import { SLIDER_THUMB_SIZE } from '../../config/designSystem/Spacing';
import { animate } from '../../utils/breathe/animate';
import { formatTimer } from '../../utils/breathe/formatTimer';
import { isIos, isWeb } from '../../config/designSystem/Layout';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';
import { useInterval } from '../../hooks/useInterval';
import { useOnMount } from '../../hooks/useOnMount';
import { useStores } from '../../hooks/useStores';


type Props = {
  limit: number;
  onLimitReached: () => void;
};

export const buttonSize = 60;


export const ExerciceTimer: FC<Props> = ({ limit, onLimitReached }) => {
  const rootStore = useStores();
  const labels = rootStore?.language?.translate?.MOBILE?.SNACKING?.BREATHE;
  const [elapsedTime, setElapsedTime] = useState(0);
  const [opacityAnimVal] = useState(new Animated.Value(0));
  const {width, height} = useAvailableDimensions();

  const duration = rootStore?.technique?.getTimerDuration;

  const labelNoLimit = labels?.SESSION_ONGOING?labels.SESSION_ONGOING: 'Session ongoing';
  const labelOneMinute = labels?.SESSION_OF_1_MINUTE? labels.SESSION_OF_1_MINUTE: 'Session of 1 minute';
  const labelLimit = labels?.SESSION_OF_X_MINUTES? labels.SESSION_OF_X_MINUTES: 'Session of {{duration}} minutes';
  const labelEnd = limit? (duration===1? labelOneMinute:labelLimit.replace('{{duration}}', duration.toString())): labelNoLimit;


  const increaseElapsedTime = () => {
    setElapsedTime(prevElapsedTime => prevElapsedTime + 100);
  };

  useInterval(increaseElapsedTime, 100);

  const showContainerAnimation = animate(opacityAnimVal, {
    toValue: 1,
  });

  useOnMount(() => {
    showContainerAnimation.start();
    return () => {
      showContainerAnimation.stop();
      setElapsedTime(0);
    };
  });

  useEffect(() => {
    if (limit && elapsedTime  >= limit) {
      setElapsedTime(0);
      onLimitReached();
    }
  }, [limit, elapsedTime]);

  const containerAnimatedStyle = {
    opacity: opacityAnimVal.interpolate({
      inputRange: [0, 1],
      outputRange: [0, 1],
    }),
  };

  const timerText = limit
    ? formatTimer(limit / 1000 - elapsedTime/1000)
    : formatTimer(Math.round(elapsedTime/1000));

  const thumbColor = isWeb? '#FFFFFF33': '#FFFFFFFF';

  const sliderComponent = () => {
    const scaleIos = 0.5;
    const scaleAndroid = 1;
    const widthIOS = 100 * (1 / scaleIos);
    const widthAndroid = 100 * (1 / scaleAndroid);
    if(isWeb) {
      return (  <Slider maximumValue={limit} disabled={true} value={elapsedTime} minimumTrackTintColor={COLORS.brand[500] }
        maximumTrackTintColor={NEUTRAL_TEXT500+'33'} thumbTintColor={thumbColor} thumbSize={SLIDER_THUMB_SIZE} />);
    } else {
      return (<View
        style={{
          transform: [
            { scaleX: isIos ? scaleIos : scaleAndroid },
            { scaleY: isIos ? scaleIos : scaleAndroid },
          ],
        }}>
        <Slider maximumValue={limit} disabled={true} value={elapsedTime} minimumTrackTintColor={COLORS.brand[500] }
          maximumTrackTintColor={NEUTRAL_TEXT500+'33'} thumbTintColor={thumbColor} thumbSize={SLIDER_THUMB_SIZE} style={{
            flex: 1,
            width: isIos ? `${widthIOS}%` : `${widthAndroid}%`,
            alignSelf: 'center',
          }}/>
      </View>);
    }
  };


  return (
    <Animated.View style={[styles.container, containerAnimatedStyle]}>

      <View style={[{width:0.5*width, alignSelf: 'center', maxWidth: 600, rowGap: 15}, !limit && {alignItems: 'center'}]} >
        {limit ? (
          <>
            {sliderComponent()}
            <View style={{flexDirection:'row', justifyContent:'space-between'}}>
              <View>
                <ParagraphSRegular>{formatTimer(Math.round(elapsedTime/1000))}</ParagraphSRegular>
              </View>
              <View>
                <ParagraphSRegular>-{formatTimer(Math.round(limit / 1000 - elapsedTime/1000))}</ParagraphSRegular>
              </View>
            </View>
          </>): (<ParagraphMRegular color={COLORS.brand[500] }>{timerText}</ParagraphMRegular>)}
        <View style={{alignItems:'center',  justifyContent:'center', marginTop: 20}} >
          <ParagraphMRegular>
            {labelEnd}
          </ParagraphMRegular>
        </View>
      </View>
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginTop: buttonSize,
  },
  text: {
    textAlign: 'center',
    fontSize: 26,
    color: 'white',
  },
});
